<template>
  <div class="msgPushSet">
    <Card class="card">
      <div class="topTit">
        <p>应用通知</p>
      </div>
      <Table :columns="serveInform" :data="appInformDatas">
        <!-- 通知状态 -->
        <template slot-scope="{ row }" slot="statusInform">
          <i-switch
            size="large"
            v-model="row.statusChange"
            @on-change="changeStstus(row.id, $event)"
          >
            <span slot="open">ON</span>
            <span slot="close">OFF</span>
          </i-switch>
        </template>
        <!-- 操作对象 -->
        <template slot-scope="{ row }" slot="actionObj">
          <div>
            <p>服务使用者</p>
            <p v-if="row.scene == '应用开通服务通知'">服务使用者子账号</p>
          </div>
        </template>
        <!-- 通知对象 -->
        <template slot-scope="{ row }" slot="objInform">
          <div>
            <div>
              <Checkbox
                v-model="row.parentSacChange"
                @on-change="changeObj('patentUse', row, $event)"
                >服务使用者</Checkbox
              >
            </div>
            <div>
              <Checkbox
                v-model="row.childSacChange"
                @on-change="changeObj('childUse', row, $event)"
                v-if="row.scene == '应用开通服务通知'"
                >服务使用者</Checkbox
              >
              <Checkbox
                v-model="row.childSacOneselfChange"
                @on-change="changeObj('childUseChild', row, $event)"
                v-if="row.scene == '应用开通服务通知'"
                >服务使用者子账号</Checkbox
              >
            </div>
          </div>
        </template>
        <!-- 通知类型 -->
        <template slot-scope="{ row }" slot="typeInform">
          <span>立即通知</span>
        </template>
        <!-- 通知模板 -->
        <template slot-scope="{ row }" slot="action">
          <span
            v-if="row.statusChange"
            class="fontblue mr-16 fontcursor"
            v-permission="['update']"
            @click="link('/message/messageedit', row)"
            >编辑</span
          >
        </template>
      </Table>
      <div class="topTit">
        <p>服务通知</p>
      </div>
      <Table :columns="serveInform" :data="serveInformDatas">
        <!-- 通知状态 -->
        <template slot-scope="{ row }" slot="statusInform">
          <i-switch
            size="large"
            v-model="row.statusChange"
            @on-change="changeStstus(row.id, $event)"
          >
            <span slot="open">ON</span>
            <span slot="close">OFF</span>
          </i-switch>
        </template>
        <!-- 操作对象 -->
        <template slot-scope="{ row }" slot="actionObj">
          <div>
            <p
              v-if="
                row.scene != '服务启用通知' &&
                  row.scene != '服务禁用通知' &&
                  row.scene != '服务异常通知'
              "
            >
              服务提供商
            </p>
            <p
              v-if="
                row.scene != '服务启用通知' &&
                  row.scene != '服务禁用通知' &&
                  row.scene != '服务异常通知'
              "
            >
              服务提供商子账号
            </p>
            <p
              v-if="row.scene == '服务启用通知' || row.scene == '服务禁用通知'"
            >
              服务使用者
            </p>
            <p
              v-if="row.scene == '服务启用通知' || row.scene == '服务禁用通知'"
            >
              服务使用者子账号
            </p>
          </div>
        </template>
        <!-- 通知对象 -->
        <template slot-scope="{ row }" slot="objInform">
          <div>
            <!-- 通知对象第一行 -->
            <div>
              <Checkbox
                v-model="row.parentSocChange"
                @on-change="changeObj('patentPro', row, $event)"
                v-if="
                  row.scene != '服务启用通知' &&
                    row.scene != '服务禁用通知' &&
                    row.scene != '服务下架通知（使用者）'
                "
                >服务提供商</Checkbox
              >
              <!-- 新加 -->
              <Checkbox
                v-model="row.parentSocChildChange"
                @on-change="changeObj('patentProChild', row, $event)"
                v-if="
                  row.scene == '服务下架通知（提供商）' ||
                    row.scene == '服务异常通知'
                "
                >服务提供商子账号</Checkbox
              >
              <Checkbox
                v-model="row.parentSacChange"
                @on-change="changeObj('patentUse', row, $event)"
                v-if="
                  row.scene == '服务启用通知' ||
                    row.scene == '服务禁用通知' ||
                    row.scene == '服务下架通知（使用者）'
                "
                >服务使用者</Checkbox
              >
              <Checkbox
                v-model="row.parentSacChildChange"
                v-if="
                  row.scene == '服务启用通知' ||
                    row.scene == '服务禁用通知' ||
                    row.scene == '服务下架通知（使用者）'
                "
                @on-change="changeObj('patentUseChild', row, $event)"
                >服务使用者子账号</Checkbox
              >
            </div>
            <!-- 通知对象第二行 -->
            <div>
              <Checkbox
                v-model="row.childSocChange"
                @on-change="changeObj('childPro', row, $event)"
                v-if="
                  row.scene != '服务启用通知' &&
                    row.scene != '服务禁用通知' &&
                    row.scene != '服务异常通知' &&
                    row.scene != '服务下架通知（使用者）'
                "
                >服务提供商</Checkbox
              >
              <Checkbox
                v-model="row.childSocOneselfChange"
                @on-change="changeObj('childProChild', row, $event)"
                v-if="
                  row.scene != '服务启用通知' &&
                    row.scene != '服务禁用通知' &&
                    row.scene != '服务异常通知' &&
                    row.scene != '服务下架通知（使用者）'
                "
                >服务提供商子账号</Checkbox
              >
              <!-- 新加 -->
              <Checkbox
                v-model="row.childSacChange"
                @on-change="changeObj('childUse', row, $event)"
                v-if="
                  row.scene == '服务启用通知' ||
                    row.scene == '服务禁用通知' ||
                    row.scene == '服务下架通知（使用者）'
                "
                >服务使用者</Checkbox
              >
              <Checkbox
                v-model="row.childSacOneselfChange"
                @on-change="changeObj('childUseChild', row, $event)"
                v-if="
                  row.scene == '服务启用通知' ||
                    row.scene == '服务禁用通知' ||
                    row.scene == '服务下架通知（使用者）'
                "
                >服务使用者子账号</Checkbox
              >
            </div>
          </div>
        </template>
        <!-- 通知类型 -->
        <template slot-scope="{ row }" slot="typeInform">
          <span>立即通知</span>
        </template>
        <!-- 通知模板 -->
        <template slot-scope="{ row }" slot="action">
          <span
            v-if="row.statusChange"
            class="fontblue mr-16 fontcursor"
            @click="link('/message/messageedit', row)"
            >编辑</span
          >
        </template>
      </Table>
      <!-- 审批通知------- -->
      <div class="topTit">
        <p>审批通知</p>
      </div>
      <Table :columns="serveInform" :data="checkInformDatas">
        <!-- 通知状态 -->
        <template slot-scope="{ row }" slot="statusInform">
          <i-switch
            size="large"
            v-model="row.statusChange"
            @on-change="changeStstus(row.id, $event)"
          >
            <span slot="open">ON</span>
            <span slot="close">OFF</span>
          </i-switch>
        </template>
        <!-- 操作对象 -->
        <template slot-scope="{ row }" slot="actionObj">
          <div>
            <!-- ||
                row.scene == '资源申请通过通知' ||
                row.scene == '资源申请失败通知'  -->
            <p
              v-if="row.scene == '认证通过通知' || row.scene == '认证失败通知'"
            >
              服务使用者
            </p>
            <p>服务提供商</p>
            <!-- row.scene == '资源申请通过通知' ||
                row.scene == '资源申请失败通知' || -->
            <p
              v-if="
                row.scene == '服务下架申请通过通知（提供商）' ||
                  row.scene == '服务下架申请通过通知（使用者）'
              "
            >
              服务提供商子账号
            </p>
          </div>
        </template>
        <!-- 通知对象 -->
        <template slot-scope="{ row }" slot="objInform">
          <div>
            <!-- 通知对象第一行 -->
            <div>
              <Checkbox
                v-model="row.parentSocChange"
                @on-change="changeObj('patentPro', row, $event)"
                v-if="
                  row.scene == '服务上架申请通过通知' ||
                    row.scene == '服务下架申请通过通知' ||
                    row.scene == '服务上架申请失败通知' ||
                    row.scene == '服务下架申请失败通知' ||
                    row.scene == '服务下架申请通过通知（提供商）'
                "
                >服务提供商</Checkbox
              >
              <Checkbox
                v-model="row.parentSocChildChange"
                @on-change="changeObj('patentProChild', row, $event)"
                v-if="
                  row.scene == '服务上架申请通过通知' ||
                    row.scene == '服务下架申请通过通知' ||
                    row.scene == '服务上架申请失败通知' ||
                    row.scene == '服务下架申请失败通知' ||
                    row.scene == '服务下架申请通过通知（提供商）'
                "
                >服务提供商子账号</Checkbox
              >
              <!-- row.scene == '资源申请通过通知' ||
                row.scene == '资源申请失败通知' || -->
              <Checkbox
                v-model="row.parentSacChange"
                @on-change="changeObj('patentUse', row, $event)"
                v-if="
                  row.scene == '认证通过通知' ||
                    row.scene == '认证失败通知' ||
                    row.scene == '服务下架申请通过通知（使用者）'
                "
                >服务使用者</Checkbox
              >
              <Checkbox
                v-model="row.parentSacChildChange"
                @on-change="changeObj('patentUseChild', row, $event)"
                v-if="row.scene == '服务下架申请通过通知（使用者）'"
                >服务使用者子账号</Checkbox
              >
            </div>
            <!-- 通知对象第二行 -->
            <div>
              <!-- ||
                  row.scene == '资源申请通过通知' ||
                  row.scene == '资源申请失败通知'  -->
              <Checkbox
                v-model="row.parentSocChange"
                @on-change="changeObj('patentPro', row, $event)"
                v-if="
                  row.scene == '认证通过通知' || row.scene == '认证失败通知'
                "
                >服务提供商</Checkbox
              >
              <Checkbox
                v-model="row.childSacChange"
                @on-change="changeObj('childUse', row, $event)"
                v-if="row.scene == '服务下架申请通过通知（使用者）'"
                >服务使用者</Checkbox
              >
              <Checkbox
                v-model="row.childSacOneselfChange"
                @on-change="changeObj('childUseChild', row, $event)"
                v-if="row.scene == '服务下架申请通过通知（使用者）'"
                >服务使用者子账号</Checkbox
              >
            </div>
            <!-- 通知对象第三行 服务提供商子账号-->
            <div>
              <!-- row.scene == '资源申请通过通知' ||
                  row.scene == '资源申请失败通知' ||  -->
              <Checkbox
                v-model="row.childSocChange"
                @on-change="changeObj('childPro', row, $event)"
                v-if="row.scene == '服务下架申请通过通知（提供商）'"
                >服务提供商</Checkbox
              >
              <!-- row.scene == '资源申请通过通知' ||
                  row.scene == '资源申请失败通知' ||  -->
              <Checkbox
                v-model="row.childSocOneselfChange"
                @on-change="changeObj('childProChild', row, $event)"
                v-if="row.scene == '服务下架申请通过通知（提供商）'"
                >服务提供商子账号</Checkbox
              >
            </div>
          </div>
        </template>
        <!-- 通知类型 -->
        <template slot-scope="{ row }" slot="typeInform">
          <span>立即通知</span>
        </template>
        <!-- 通知模板 -->
        <template slot-scope="{ row }" slot="action">
          <span
            v-if="row.statusChange"
            class="fontblue mr-16 fontcursor"
            @click="link('/message/messageedit', row)"
            >编辑</span
          >
        </template>
      </Table>
      <div class="topTit">
        <p>工单通知</p>
      </div>
      <Table :columns="serveInform" :data="workoderInformDatas">
        <!-- 通知状态 -->
        <template slot-scope="{ row }" slot="statusInform">
          <i-switch
            size="large"
            v-model="row.statusChange"
            @on-change="changeStstus(row.id, $event)"
          >
            <span slot="open">ON</span>
            <span slot="close">OFF</span>
          </i-switch>
        </template>
        <!-- 操作对象 -->
        <template slot-scope="{ row }" slot="actionObj">
          <div>
            <p>服务使用者</p>
            <p v-if="row.scene == '工单到时关闭通知'">服务提供商</p>
          </div>
        </template>
        <!-- 通知对象 -->
        <template slot-scope="{ row }" slot="objInform">
          <div>
            <div>
              <Checkbox
                v-model="row.parentSacChange"
                @on-change="changeObj('patentUse', row, $event)"
                >服务使用者</Checkbox
              >
            </div>
            <div>
              <Checkbox
                v-model="row.parentSocChange"
                @on-change="changeObj('patentPro', row, $event)"
                v-if="row.scene == '工单到时关闭通知'"
                >服务提供商</Checkbox
              >
            </div>
          </div>
        </template>
        <!-- 通知类型 -->
        <template slot-scope="{ row }" slot="typeInform">
          <span>立即通知</span>
        </template>
        <!-- 通知模板 -->
        <template slot-scope="{ row }" slot="action">
          <span
            v-if="row.statusChange"
            class="fontblue mr-16 fontcursor"
            @click="link('/message/messageedit', row)"
            >编辑</span
          >
        </template>
      </Table>
      <div class="topTit">
        <p>模型训练通知</p>
      </div>
      <Table :columns="serveInform" :data="modelInformDatas">
        <!-- 通知状态 -->
        <template slot-scope="{ row }" slot="statusInform">
          <i-switch
            size="large"
            v-model="row.statusChange"
            @on-change="changeStstus(row.id, $event)"
          >
            <span slot="open">ON</span>
            <span slot="close">OFF</span>
          </i-switch>
        </template>
        <!-- 操作对象 -->
        <template slot-scope="{ row }" slot="actionObj">
          <div>
            <p>服务提供商</p>
            <p>服务提供商子账号</p>
          </div>
        </template>
        <!-- 通知对象 -->
        <template slot-scope="{ row }" slot="objInform">
          <div>
            <div>
              <Checkbox
                v-model="row.parentSocChange"
                @on-change="changeObj('patentPro', row, $event)"
                >服务提供商</Checkbox
              >
            </div>
            <div>
              <Checkbox
                v-model="row.childSocChange"
                @on-change="changeObj('childPro', row, $event)"
                >服务提供商</Checkbox
              >
              <Checkbox
                v-model="row.childSocOneselfChange"
                @on-change="changeObj('childProChild', row, $event)"
                >服务提供商子账号</Checkbox
              >
            </div>
          </div>
        </template>
        <!-- 通知类型 -->
        <template slot-scope="{ row }" slot="typeInform">
          <span>立即通知</span>
        </template>
        <!-- 通知模板 -->
        <template slot-scope="{ row }" slot="action">
          <span
            v-if="row.statusChange"
            class="fontblue mr-16 fontcursor fontcursor"
            @click="link('/message/messageedit', row)"
            >编辑</span
          >
        </template>
      </Table>
    </Card>
  </div>
</template>

<script>
import { getMsgAll, switchStstus, objStstus } from "@/api/msg";

export default {
  name: "MsgPushSet",
  data() {
    return {
      switch1: false,
      adminList: "",
      // table表头
      serveInform: [
        {
          title: "通知场景",
          key: "scene",
          tooltip: true,
          minWidth: 180,
        },
        {
          title: "通知状态",
          slot: "statusInform",
          tooltip: true,
          minWidth: 100,
        },
        {
          title: "操作对象",
          slot: "actionObj",
          tooltip: true,
          minWidth: 150,
        },
        {
          title: "通知对象",
          slot: "objInform",
          tooltip: true,
          minWidth: 520,
        },
        {
          title: "通知类型",
          slot: "typeInform",
          tooltip: true,
          minWidth: 140,
        },
        {
          title: "通知模板",
          slot: "action",
          tooltip: true,
          minWidth: 140,
        },
      ],
      // 应用通知数据
      appInformData: [
        {
          sence: "1",
          status: true,
          serviceuser: ["1", "2"],
          typeInform: "立即通知",
        },
        {
          sence: "2",
          status: false,
          serviceuser: ["1"],
          typeInform: "立即通知",
        },
        {
          sence: "3",
          status: false,
          serviceuser: ["1"],
          typeInform: "立即通知",
        },
      ],
      // 服务通知数据
      serveInformData: [
        {
          sence: "1",
          status: true,
          serviceuser: ["1", "2"],
          typeInform: "立即通知",
        },
        {
          sence: "2",
          status: false,
          serviceuser: ["1"],
          typeInform: "立即通知",
        },
        {
          sence: "3",
          status: false,
          serviceuser: ["1"],
          typeInform: "立即通知",
        },
        {
          sence: "4",
          status: true,
          serviceuser: ["1"],
          typeInform: "立即通知",
        },
        {
          sence: "5",
          status: false,
          serviceuser: ["1"],
          typeInform: "立即通知",
        },
        {
          sence: "6",
          status: false,
          serviceuser: ["1"],
          typeInform: "立即通知",
        },
        {
          sence: "7",
          status: false,
          serviceuser: ["1"],
          typeInform: "立即通知",
        },
      ],
      // 审批通知数据
      checkInformData: [
        {
          sence: "1",
          status: true,
          serviceuser: ["1", "2"],
          typeInform: "立即通知",
        },
        {
          sence: "2",
          status: false,
          serviceuser: ["1"],
          typeInform: "立即通知",
        },
        {
          sence: "3",
          status: false,
          serviceuser: ["1"],
          typeInform: "立即通知",
        },
        {
          sence: "4",
          status: true,
          serviceuser: ["1", "2"],
          typeInform: "立即通知",
        },
        {
          sence: "5",
          status: false,
          serviceuser: ["1"],
          typeInform: "立即通知",
        },
        // {
        //   sence: "6",
        //   status: false,
        //   serviceuser: ["1"],
        //   typeInform: "立即通知"
        // },
        // {
        //   sence: "7",
        //   status: false,
        //   serviceuser: ["1"],
        //   typeInform: "立即通知"
        // },
        {
          sence: "8",
          status: false,
          serviceuser: ["1"],
          typeInform: "立即通知",
        },
      ],
      // 工单通知数据
      workoderInformData: [
        {
          sence: "1",
          status: true,
          serviceuser: ["1", "2"],
          typeInform: "立即通知",
        },
        {
          sence: "2",
          status: false,
          serviceuser: ["1"],
          typeInform: "立即通知",
        },
        {
          sence: "3",
          status: false,
          serviceuser: ["1"],
          typeInform: "立即通知",
        },
      ],
      // 模型训练通知数据
      modelInformData: [
        {
          sence: "1",
          status: true,
          serviceuser: ["1", "2"],
          typeInform: "立即通知",
        },
        {
          sence: "2",
          status: false,
          serviceuser: ["1"],
          typeInform: "立即通知",
        },
        {
          sence: "3",
          status: false,
          serviceuser: ["1"],
          typeInform: "立即通知",
        },
      ],
      // 管理员列表
      cityList: [
        {
          value: "New York",
          label: "New York",
        },
        {
          value: "London",
          label: "London",
        },
        {
          value: "Sydney",
          label: "Sydney",
        },
      ],
      modelTrain: {
        parentSoc: "0", //服务提供商==服务提供商
        childSoc: "0", //服务提供商子账号==服务提供商
        childSocOneself: "0", //服务提供商子账号==服务提供商子账号
        parentSac: "0", //服务使用者==服务使用者
        childSac: "0", //服务使用者子账号==服务使用者
        childSacOneself: "0", //服务使用者子账号==服务使用者子账号
        parentSocChild: "0", //服务提供商==服务提供商子账号
        parentSacChild: "0", //服务使用者==服务使用者子账号
      },
      appInformDatas: [], //应用通知数据
      serveInformDatas: [], //服务通知数据
      checkInformDatas: [], //审批通知数据
      workoderInformDatas: [], //工单通知数据
      modelInformDatas: [], //模型训练通知数据
    };
  },
  created() {
    this.getList();
  },
  methods: {
    // 获取全部消息
    getList() {
      getMsgAll()
        .then((res) => {
          let informList = res.data.data;
          for (let k = 0; k < informList.length; k++) {
            // 应用通知数据
            if (informList[k].type == "应用通知") {
              console.log("应用通知", informList[k].list);
              this.appInformDatas = informList[k].list;
              if (this.appInformDatas && this.appInformDatas.length) {
                this.appInformDatas.forEach((item) => {
                  // 通知状态的转换
                  if (item.status == "0") {
                    item.statusChange = false;
                  } else {
                    item.statusChange = true;
                  }
                  // 通知对象(服务使用者子账号==服务使用者)的转换
                  if (item.childSac == "0") {
                    item.childSacChange = false;
                  } else {
                    item.childSacChange = true;
                  }
                  // 通知对象(服务使用者子账号==服务使用者子账号)的转换
                  if (item.childSacOneself == "0") {
                    item.childSacOneselfChange = false;
                  } else {
                    item.childSacOneselfChange = true;
                  }
                  // 通知对象(服务使用者==服务使用者)的转换
                  if (item.parentSac == "0") {
                    item.parentSacChange = false;
                  } else {
                    item.parentSacChange = true;
                  }
                });
              }
            }
            // 服务通知数据
            if (informList[k].type == "服务通知") {
              console.log("服务通知", informList[k].list);
              this.serveInformDatas = informList[k].list;
              if (this.serveInformDatas && this.serveInformDatas.length) {
                this.serveInformDatas.forEach((item) => {
                  // 通知状态的转换
                  if (item.status == "0") {
                    item.statusChange = false;
                  } else {
                    item.statusChange = true;
                  }
                  // 通知对象(服务提供商==服务提供商)的转换
                  if (item.parentSoc == "0") {
                    item.parentSocChange = false;
                  } else {
                    item.parentSocChange = true;
                  }
                  // 通知对象(服务提供商==服务提供商子账号)的转换
                  if (item.parentSocChild == "0") {
                    item.parentSocChildChange = false;
                  } else {
                    item.parentSocChildChange = true;
                  }
                  // 通知对象(服务使用者==服务使用者)的转换
                  if (item.parentSac == "0") {
                    item.parentSacChange = false;
                  } else {
                    item.parentSacChange = true;
                  }
                  // 通知对象(服务使用者==服务使用者子账号)的转换
                  if (item.parentSacChild == "0") {
                    item.parentSacChildChange = false;
                  } else {
                    item.parentSacChildChange = true;
                  }
                  // 通知对象(服务提供商子账号==服务提供商)的转换
                  if (item.childSoc == "0") {
                    item.childSocChange = false;
                  } else {
                    item.childSocChange = true;
                  }
                  // 通知对象(服务提供商子账号==服务提供商子账号)的转换
                  if (item.childSocOneself == "0") {
                    item.childSocOneselfChange = false;
                  } else {
                    item.childSocOneselfChange = true;
                  }
                  // 通知对象(服务使用者子账号==服务使用者)的转换
                  if (item.childSac == "0") {
                    item.childSacChange = false;
                  } else {
                    item.childSacChange = true;
                  }
                  // 通知对象(服务使用者子账号==服务使用者子账号)的转换
                  if (item.childSacOneself == "0") {
                    item.childSacOneselfChange = false;
                  } else {
                    item.childSacOneselfChange = true;
                  }
                });
              }
            }
            // 审批通知数据
            if (informList[k].type == "审批通知") {
              console.log("审批通知", informList[k].list);
              this.checkInformDatas = informList[k].list.filter(
                (x) =>
                  x.scene != "资源申请失败通知" && x.scene != "资源申请通过通知"
              );
              if (this.checkInformDatas && this.checkInformDatas.length) {
                this.checkInformDatas.forEach((item) => {
                  // 通知状态的转换
                  if (item.status == "0") {
                    item.statusChange = false;
                  } else {
                    item.statusChange = true;
                  }
                  // 通知对象(服务提供商==服务提供商)的转换
                  if (item.parentSoc == "0") {
                    item.parentSocChange = false;
                  } else {
                    item.parentSocChange = true;
                  }
                  // 通知对象(服务提供商==服务提供商子账号)的转换
                  if (item.parentSocChild == "0") {
                    item.parentSocChildChange = false;
                  } else {
                    item.parentSocChildChange = true;
                  }
                  // 通知对象(服务使用者==服务使用者)的转换
                  if (item.parentSac == "0") {
                    item.parentSacChange = false;
                  } else {
                    item.parentSacChange = true;
                  }
                  // 通知对象(服务使用者==服务使用者子账号)的转换
                  if (item.parentSacChild == "0") {
                    item.parentSacChildChange = false;
                  } else {
                    item.parentSacChildChange = true;
                  }
                  // 通知对象(服务提供商子账号==服务提供商)的转换
                  if (item.childSoc == "0") {
                    item.childSocChange = false;
                  } else {
                    item.childSocChange = true;
                  }
                  // 通知对象(服务提供商子账号==服务提供商子账号)的转换
                  if (item.childSocOneself == "0") {
                    item.childSocOneselfChange = false;
                  } else {
                    item.childSocOneselfChange = true;
                  }
                  // 通知对象(服务使用者子账号==服务使用者)的转换
                  if (item.childSac == "0") {
                    item.childSacChange = false;
                  } else {
                    item.childSacChange = true;
                  }
                  // 通知对象(服务使用者子账号==服务使用者子账号)的转换
                  if (item.childSacOneself == "0") {
                    item.childSacOneselfChange = false;
                  } else {
                    item.childSacOneselfChange = true;
                  }
                });
              }
            }
            // 工单通知数据
            if (informList[k].type == "工单通知") {
              console.log("工单通知", informList[k].list);
              this.workoderInformDatas = informList[k].list;
              if (this.workoderInformDatas && this.workoderInformDatas.length) {
                this.workoderInformDatas.forEach((item) => {
                  // 通知状态的转换
                  if (item.status == "0") {
                    item.statusChange = false;
                  } else {
                    item.statusChange = true;
                  }
                  // 通知对象(服务提供商==服务提供商)的转换
                  if (item.parentSoc == "0") {
                    item.parentSocChange = false;
                  } else {
                    item.parentSocChange = true;
                  }
                  // 通知对象(服务使用者==服务使用者)的转换
                  if (item.parentSac == "0") {
                    item.parentSacChange = false;
                  } else {
                    item.parentSacChange = true;
                  }
                });
              }
            }
            // 模型训练通知数据
            if (informList[k].type == "模型训练通知") {
              console.log("模型训练通知", informList[k].list);
              this.modelInformDatas = informList[k].list;
              if (this.modelInformDatas && this.modelInformDatas.length) {
                this.modelInformDatas.forEach((item) => {
                  // 通知状态的转换
                  if (item.status == "0") {
                    item.statusChange = false;
                  } else {
                    item.statusChange = true;
                  }
                  // 通知对象(服务提供商==服务提供商)的转换
                  if (item.parentSoc == "0") {
                    item.parentSocChange = false;
                  } else {
                    item.parentSocChange = true;
                  }
                  // 通知对象(服务提供商子账号==服务提供商)的转换
                  if (item.childSoc == "0") {
                    item.childSocChange = false;
                  } else {
                    item.childSocChange = true;
                  }
                  // 通知对象(服务提供商子账号==服务提供商子账号)的转换
                  if (item.childSocOneself == "0") {
                    item.childSocOneselfChange = false;
                  } else {
                    item.childSocOneselfChange = true;
                  }
                });
              }
            }
          }
        })
        .catch((err) => {
          console.log("接口请求失败");
        });
    },
    // 通知状态改变
    changeStstus(id, status) {
      let statusChange;
      if (status == true) {
        statusChange = "1";
      } else {
        statusChange = "0";
      }
      let query = {
        id: id,
        status: statusChange,
      };
      console.log("query", query);
      switchStstus(query)
        .then((res) => {
          let tip = status ? "开启" : "关闭";
          // this.$Message.info(tip+'成功');
          console.log("res", res);
        })
        .catch((err) => {
          console.log("接口请求失败");
        });
    },
    // 通知对象改变
    changeObj(flag, row, status) {
      // 清除上次数据，防止checkbox重复选中
      this.modelTrain.parentSoc = row.parentSoc || "0";
      this.modelTrain.childSoc = row.childSoc || "0";
      this.modelTrain.childSocOneself = row.childSocOneself || "0";
      this.modelTrain.parentSac = row.parentSac || "0";
      this.modelTrain.childSac = row.childSac || "0";
      this.modelTrain.childSacOneself = row.childSacOneself || "0";
      this.modelTrain.parentSocChild = row.parentSocChild || "0";
      this.modelTrain.parentSacChild = row.parentSacChild || "0";

      // 服务提供商==服务提供商(patentPro)
      if (flag == "patentPro") {
        console.log("服务提供商==服务提供商");
        if (status == true) {
          this.modelTrain.parentSoc = "1";
        } else {
          this.modelTrain.parentSoc = "0";
        }
      }
      // 服务提供商==服务提供商子账号(patentProChild)
      if (flag == "patentProChild") {
        console.log("服务提供商==服务提供商子账号");
        if (status == true) {
          this.modelTrain.parentSocChild = "1";
        } else {
          this.modelTrain.parentSocChild = "0";
        }
      }
      // 服务提供商子账号==服务提供商(childPro)
      if (flag == "childPro") {
        if (status == true) {
          this.modelTrain.childSoc = "1";
        } else {
          this.modelTrain.childSoc = "0";
        }
      }
      // 服务提供商子账号==服务提供商子账号(childProChild)
      if (flag == "childProChild") {
        if (status == true) {
          this.modelTrain.childSocOneself = "1";
        } else {
          this.modelTrain.childSocOneself = "0";
        }
      }
      // 服务提使用者==服务提使用者(patentUse)
      if (flag == "patentUse") {
        if (status == true) {
          this.modelTrain.parentSac = "1";
        } else {
          this.modelTrain.parentSac = "0";
        }
      }
      // 服务提使用者==服务提使用者子账号(patentUseChild)
      if (flag == "patentUseChild") {
        if (status == true) {
          this.modelTrain.parentSacChild = "1";
        } else {
          this.modelTrain.parentSacChild = "0";
        }
      }
      // 服务提使用者子账号==服务提使用者(childUse)
      if (flag == "childUse") {
        if (status == true) {
          this.modelTrain.childSac = "1";
        } else {
          this.modelTrain.childSac = "0";
        }
      }
      // 服务提使用者子账号==服务提使用者子账号(childUseChild)
      if (flag == "childUseChild") {
        if (status == true) {
          this.modelTrain.childSacOneself = "1";
        } else {
          this.modelTrain.childSacOneself = "0";
        }
      }
      let query = {
        id: row.id,
        parentSoc: this.modelTrain.parentSoc,
        childSoc: this.modelTrain.childSoc,
        childSocOneself: this.modelTrain.childSocOneself,
        parentSac: this.modelTrain.parentSac,
        childSac: this.modelTrain.childSac,
        childSacOneself: this.modelTrain.childSacOneself,
        parentSocChild: this.modelTrain.parentSocChild,
        parentSacChild: this.modelTrain.parentSacChild,
      };
      console.log("query", query);
      objStstus(query)
        .then((res) => {
          console.log("res", res);
          this.getList();
        })
        .catch((err) => {
          console.log("接口请求失败");
        });
    },
    // 页面跳转
    link(path, item) {
      if (item) {
        this.$router.push({
          path: path,
          query: {
            id: item.id,
          },
        });
      } else {
        this.$router.push({ path: path });
      }
    },
  },
};
</script>

<style lang="scss">
.msgPushSet {
  width: 100%;
  .card {
    width: 100%;
    min-height: calc(100vh - 150px);
    font-size: 14px;
    color: #2f4061;
    .topTit {
      width: 100%;
      font-size: 16px;
      font-family: MicrosoftYaHeiSemibold;
      color: #2f4061;
      font-weight: bold;
      border-bottom: 1px solid #ebedf0;
      box-sizing: border-box;
      padding: 10px 0px;
    }
  }
}
</style>
